import React from 'react'
import {request} from '../../helpers/request.js';
import {Collapse, Fade, ListGroup, ListGroupItem, Alert, Input, Panel} from 'react-bootstrap'
import Icon from 'react-fa'
import {t} from '../../helpers/translate'
import StaticTextComponent from './StaticTextComponent';
import {formatMoney} from '../../helpers/formatMoney';
let config = require('config');

class InvoiceRefundComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      processingRefund: false,
      refundSuccessful: false,
      refundErrors: null
    }
  }

  processRefund() {
    let data = {
      payment_provider: this.props.provider,
      additional_data: {
        invoice: [
          {
            amount: -this.props.quoteResponseData.premium_difference
          }
        ]
      }
    };
    this.setState({
        processingRefund: true,
        refundErrors: null
      }, () => {
        request(`${config.default.api}/premium/charge/${this.props.source}/${this.props.quoteResponseData.id}`, 'POST', data, (response, statusCode) => {
          if (statusCode === 200) {
            this.setState({
              refundSuccessful: true
            }, this.props.onRefundSuccess)
          } else if (statusCode == 400) {
            this.setState({
              refundSuccessful: false,
              refundErrors: response.messages
            })
          }
          this.setState({
            processingRefund: false
          })
        });
      }
    )
  }

  cancelPayment() {
    this.setState({
      processingRefund: false
    }, this.props.onCancel);
  }

  render() {
    return (
      <div ref="refundForm">
      {
        this.props.quoteResponseData ?
          <div className="form-group">
          <label className="text-uppercase">{t('Refund')}</label>
          <StaticTextComponent value={formatMoney(-this.props.quoteResponseData.premium_difference, this.props.quoteResponseData.currency)}/>
          </div>: null
      }
      {
        (() => {
          if (this.state.refundErrors) {
            return <Alert bsStyle="danger">
              {this.state.refundErrors.map((message) => <p>{message}</p>)}
            </Alert>
          }
        })()
      }
      <div className="btn-group pull-left">
        <button className="btn button-primary"
                onClick={this.cancelPayment.bind(this)}
                disabled={this.state.processingPayment || this.state.paymentSuccessful || !this.props.quoteResponseData}>
          {t('Cancel Refund')}
        </button>
        <button className="btn button-secondary"
                onClick={this.processRefund.bind(this)}
                disabled={this.state.processingRefund || this.state.refundSuccessful || !this.props.quoteResponseData}
                bsStyle={this.state.refundSuccessful ? 'success' : 'primary'}>
          {this.state.processingRefund && !this.state.refundSuccessful ? <Icon spin name="spinner"/> : null}
          {' '}
          {this.state.refundSuccessful ?
            [<Icon name="check"/>, <span>{ t('Refund Successful')}</span>] : t('Update Policy')}
        </button>
      </div>

      </div>
    )
  }
}

InvoiceRefundComponent.displayName = 'InvoiceRefundComponent';
export default InvoiceRefundComponent;



// WEBPACK FOOTER //
// ./src/components/common/InvoiceRefundComponent.js